import React from 'react';
import { IconFolder } from '@bynder/icons';
import { IdentityRole } from 'packages/store/sharing/types';
import { getCreativeSharingIcon } from 'packages/pages/components/card/utils';
import { AllowedIndicatorTypes } from 'packages/pages/components/templates/types';
import { Creative } from 'packages/store/creatives/types';
import { Template } from 'packages/store/templates/types';

export const getTemplateIcon = (
    design: Creative | Template,
    isProjectDetails: boolean,
    identityRole = IdentityRole.CONTRIBUTOR,
    allowedIndicatorTypes?: AllowedIndicatorTypes,
) => {
    if (!allowedIndicatorTypes) {
        return null;
    }

    if (allowedIndicatorTypes.folder) {
        if (design.type === 'TEMPLATE' && 'categoryId' in design && design.categoryId) {
            return <IconFolder />;
        }
    }

    if (allowedIndicatorTypes.sharing) {
        return getCreativeSharingIcon(design, isProjectDetails, identityRole);
    }

    return null;
};
